import { render } from "./Dados-Usuario.vue?vue&type=template&id=4c3e99a2&scoped=true"
import script from "./Dados-Usuario.vue?vue&type=script&lang=js"
export * from "./Dados-Usuario.vue?vue&type=script&lang=js"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3e99a2"]])

export default __exports__